module.exports = __webpack_public_path__ + "assets/ToolInfos.434b09e6e848bc1c31180ce1a1d8e972.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/en-lproj/ToolInfos.xml
// module id = 191
// module chunks = 0